import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useContext, useEffect, useState } from "react";
import { setClearConsoleCallback } from "./actions";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ConsoleContext = /*#__PURE__*/ createContext([]);
export var ConsoleWriteContext = /*#__PURE__*/ createContext(undefined);
export var ConsoleProvider = function ConsoleProvider(_ref) {
    var children = _ref.children;
    var _useState = useState([""]), _useState2 = _slicedToArray(_useState, 2), logs = _useState2[0], setLogs = _useState2[1];
    useEffect(function () {
        setClearConsoleCallback(function () {
            setLogs([""]);
        });
    }, [setLogs]);
    return ___EmotionJSX(ConsoleWriteContext.Provider, {
        value: setLogs
    }, ___EmotionJSX(ConsoleContext.Provider, {
        value: logs
    }, children));
};
export var useConsole = function useConsole() {
    var context = useContext(ConsoleContext);
    if (context === undefined) {
        throw new Error("useConsole must be used within a ConsoleProvider");
    }
    return context;
};
export var useSetConsole = function useSetConsole() {
    var context = useContext(ConsoleWriteContext);
    if (context === undefined) {
        throw new Error("useSetConsole must be used within a ConsoleWriteContext");
    }
    return context;
};
export default useConsole;
